var _excluded = ["type"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { styled } from '@mui/material';
var IconRoot = styled('svg', {
  name: 'Icon',
  slot: 'Root'
})(function () {
  return {
    width: '1em',
    height: '1em',
    fill: 'currentColor'
  };
});
var Icon = function Icon(_ref) {
  var type = _ref.type,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(IconRoot, other, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(type)
  }));
};
export default Icon;